import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { loaderActions } from "../../../_actions/loader.actions";
import CommonFilter from '../../../customControl/CommonFilter';
import CustomTable from '../../../customControl/CustomTable';
import { getAllData, verifytoken, } from '../../../services/ApiCallingUserServices';
import { ToolTip } from '../../commonClass/CommonValidation';
import { ExportExcel } from '../../commonClass/ExportExcel';
import { ClearLocalStorage } from '../../commonClass/Session';

const Userlist = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [userlist, setUserList] = useState<any>([]);

    const [filteritems, setFilterItems] = useState<any>([]);
    const [searchby, setSerachBy] = useState<any>('All');
    const [searchvalue, setSearchValue] = useState('');
    const user = useSelector((store: any) => store.userstatus.tba);
    const menuItem = useSelector((store: any) => store.menuitems.menu);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const [usertype, setUserType] = useState(3)

    const getuserdatalist = async () => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const usrdata = await getAllData('/auth/v1/getmoadminuserlist?UserType=' + usertype);
            usrdata?.data?.map((obj: any) => {
                obj.Active = obj?.IsActive ? 'Active' : 'InActive'
                obj.AreaType = obj?.AreaType?.split(",")?.join(", ")
                obj.AreaTypeFormat = obj?.AreaType?.split(",")?.slice(0, 2)?.join(", ")
                return obj;
            })
            setFilterItems(usrdata?.data ? usrdata?.data : [])
            setUserList(usrdata?.data ? usrdata?.data : []);
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }
    const columns: any = [
        {
            name: 'Sr No.',
            key: 'sqnNo',
            sortable: true,
            float: "left",
            isSearch: false,
            isExport: true,
            minWidth: "95px",
            maxWidth: "100px",
            selector: (data: any) => data?.sqnNo,
            format: (data: any) => <ToolTip data={data?.sqnNo} />
        },
        {
            name: 'User Name',
            key: 'UserName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            minWidth: "135px",
            maxWidth: "140px",
            selector: (data: any) => data?.UserName,
            format: (data: any) => <ToolTip data={data?.UserName} />
        },
        {
            name: 'Name',
            key: 'fullName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            minWidth: "200px",
            selector: (data: any) => data?.fullName,
            format: (data: any) => <ToolTip data={data?.fullName} />
        },
        {
            name: 'Domain',
            key: 'DomainName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            minWidth: "100px",
            selector: (data: any) => data?.DomainName,
            format: (data: any) => <ToolTip data={data?.DomainName} />
        },
        {
            name: 'Agency',
            key: 'AgencyName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            minWidth: "200px",
            selector: (data: any) => data?.AgencyName,
            format: (data: any) => <ToolTip data={data?.AgencyName} />
        },
        {
            name: 'Area',
            key: 'AreaType',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            minWidth: "250px",
            selector: (data: any) => data?.AreaTypeFormat,
            format: (data: any) => <ToolTip titleData={data?.AreaType} data={data?.AreaTypeFormat} />
        },
        {
            name: 'Created Name',
            key: 'CreatedName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            minWidth: "200px",
            selector: (data: any) => data?.CreatedName,
            format: (data: any) => <ToolTip data={data?.CreatedName} />
        },
        {
            name: 'Gender',
            key: 'gender',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            selector: (data: any) => data?.gender,
            format: (data: any) => <ToolTip data={data?.gender} />
        },
        {
            name: 'Department',
            key: 'departmentName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            minWidth: "200px",
            selector: (data: any) => data?.departmentName,
            format: (data: any) => <ToolTip data={data?.departmentName} />
        },
        {
            name: 'Role',
            key: 'roleName',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            minWidth: "200px",
            selector: (data: any) => data?.roleName,
            format: (data: any) => <ToolTip data={data?.roleName} />
        },
        {
            name: 'Email',
            key: 'userEmail',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            minWidth: "200px",
            selector: (data: any) => data?.userEmail,
            format: (data: any) => <ToolTip data={data?.userEmail} />
        },
        {
            name: 'Mobile Number',
            key: 'contactNo',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            minWidth: "180px",
            selector: (data: any) => data?.contactNo,
            format: (data: any) => <ToolTip data={data?.contactNo} />
        },
        {
            name: 'Active',
            key: 'Active',
            sortable: true,
            float: "left",
            isSearch: true,
            isExport: true,
            minWidth: "95px",
            maxWidth: "100px",
            selector: (data: any) => data?.Active,
            format: (data: any) => <ToolTip data={data?.Active} />
        },
        {
            name: 'Edit',
            selector: (user: any) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr' disabled={!useredit}><i className="fa-regular fa-pen-to-square" onClick={() => handleEdit(user.userMasterID)}></i></button>
        }
    ];

    useEffect(() => {
        getuserdatalist();
    }, [])

    useEffect(() => {
        //check for rights
        let pagelink = user?.find((x: any) => {
            if (x?.PageLink === window.location.pathname)
                return x?.MenuId
        });
        let mid = user?.find((x: any) => x?.MenuId === pagelink?.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter((x: any) => x?.MenuId === pagelink?.MenuId).map((obj: any) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);
        });

    }, [user])

    const handleOpen = () => {
        navigate('/Useradd', { state: { disabled: false, editdisabled: false, viewtype: 'Add', Id: 0, menuTitle: menuItem?.[0]?.pageTitle } });
    }
    const handleEdit = (id: any) => {
        dispatch(loaderActions.start());
        let Id = 0;
        userlist?.map((obj: any) => {
            Id = obj.userMasterID;
        });
        navigate('/Useradd', { state: { disabled: false, editdisabled: true, viewtype: 'Update', Id: id, menuTitle: menuItem?.[0]?.pageTitle } });
    }

    const ExportToExcel = () => {
        const dispalyname = columns?.filter((fil: any) => !fil?.omit && fil?.isExport)?.map((obj: any) => obj?.name)
        const fields = columns?.filter((fil: any) => !fil?.omit && fil?.isExport)?.map((obj: any) => obj?.key)
        ExportExcel(dispalyname, fields, userlist, "UserList", "UserList.xls");
    }
    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'>{menuItem?.[0]?.pageTitle}</h2>
            </div>
            <div className="m-2 heading_color">
                <h4>{menuItem?.[1]?.pageTitle}</h4>
            </div>
            <div className="m-2">
                <form action="" className='mt-3'>
                    <div className="d-flex justify-content-start">
                        <button type="button" disabled={!useradd} className="btn btn-primary" id="btnAdd" onClick={handleOpen} > + Create New User</button>
                    </div>
                    <br />
                    <CommonFilter
                        filtercolumns={columns}
                        filteritems={filteritems}
                        setFilterList={setUserList}
                        getdata={getuserdatalist}
                        serchdisable={false}
                        setSearchValue={setSearchValue}
                        searchvalue={searchvalue}
                        setSerachBy={setSerachBy}
                        searchby={searchby}
                    />
                    <CustomTable
                        className={"last_one_column_freeze"}
                        columns={columns}
                        data={userlist}
                        PdfExport={false}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />
                </form>
            </div >
        </>
    )
}

export default Userlist